function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon simple-discord",
    d: "M20.184 0a2.631 2.631 0 0 1 2.607 2.475V24l-2.677-2.273-1.47-1.338-1.6-1.4.67 2.205H3.677a2.482 2.482 0 0 1-2.54-2.476V2.48A2.532 2.532 0 0 1 3.677 0h16.5zm-6.118 5.683h-.03l-.2.2A8.056 8.056 0 0 1 16.91 7.42a10.878 10.878 0 0 0-3.744-1.137 10.281 10.281 0 0 0-2.475 0h-.2a8.916 8.916 0 0 0-2.81.735c-.467.2-.735.336-.735.336a7.135 7.135 0 0 1 3.21-1.537l-.135-.135a6.009 6.009 0 0 0-3.477 1.27 15.651 15.651 0 0 0-1.805 7.02 4.364 4.364 0 0 0 3.743 1.806s.4-.533.805-1a3.957 3.957 0 0 1-2.14-1.4 3.317 3.317 0 0 1 .335.2h.06a.08.08 0 0 1 .06.03v.006a.077.077 0 0 0 .06.03c.33.136.66.27.93.4a8.181 8.181 0 0 0 1.8.536 10.271 10.271 0 0 0 3.21 0 9.242 9.242 0 0 0 1.8-.535 14.426 14.426 0 0 0 1.4-.737 3.974 3.974 0 0 1-2.205 1.4c.33.466.8 1 .8 1a5.22 5.22 0 0 0 3.87-1.726 15.619 15.619 0 0 0-1.815-7.02A6.014 6.014 0 0 0 14.009 5.7l.056-.02zm.168 4.413a1.339 1.339 0 1 1-1.27 1.341 1.3 1.3 0 0 1 1.27-1.341zm-4.543 0a1.339 1.339 0 1 1-1.274 1.341A1.3 1.3 0 0 1 9.691 10.1z",
    style: {
      fill: "#7a8b99"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.b7c9f6494c573f664dfef6eb0dd7f795.svg";
export { ForwardRef as ReactComponent };